import { render, staticRenderFns } from "./BlogsSeo.vue?vue&type=template&id=77edee8c&scoped=true&"
import script from "./BlogsSeo.vue?vue&type=script&lang=js&"
export * from "./BlogsSeo.vue?vue&type=script&lang=js&"
import style0 from "./BlogsSeo.vue?vue&type=style&index=0&id=77edee8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77edee8c",
  null
  
)

export default component.exports